const fetchWorkspace = async (id: string) => {

    const response = await fetch('/api/workspaces/workspace', { method: "POST", body: JSON.stringify({ id }) });
    const responseJson = await response.json();
    return responseJson;

}

const isWorkspaceAdmin = async (workspaceId: string) => {
    const response = await fetch('/api/workspaces/is-admin', { method: "POST", body: JSON.stringify({ workspaceId }) });
    const responseJson = await response.json();
    return responseJson;
}

export const workspaceService = { fetchWorkspace, isWorkspaceAdmin }
